import { storeFinder } from './store-finder';

export const en = {
  storeFinder,
};
